import React from 'react';
import FontsDefault from '../../Assistant/DefaultStyle';
import { DefaultFlexCenter } from '../../Assistant/DefaultStyle';

function TeamCard({ item }) {
  return (
    <div
      key={item.key}
      className={`p-6 hover:bg-amber hover:border-amber cursor-pointer rounded-lg border justify-center text-center shadow-md shadow-gray500`}
    >
      <div className={`${DefaultFlexCenter} text-center`}>
        <img src={item.img} alt='img' className='w-60 h-60 rounded-full' />
      </div>
      <h5
        className={`mb-2 mt-4 ${FontsDefault.text2xl} font-bold text-gray500`}
      >
        {item.name}
      </h5>

      <h5
        className={`mb-2 mt-4 ${FontsDefault.text2xl} font-bold text-gray700`}
      >
        {item.title}
      </h5>
      <p className={`mb-3 font-black text-gray500`}>
        {item.description}
      </p>
    </div>
  );
}

export default TeamCard;
